"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _notification = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/notification"));
var _intercom = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/intercom"));
var _user = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user"));
var _hamburg = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/hamburg"));
var _group = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/group"));
var _icon = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/icon"));
var _style = require("webmotors-react-pj/frame/header/logged/items/style");
var _search = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/search"));
var _config = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
var _utils = require("webmotors-react-pj/utils");
var _logo = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/logo"));
var _default = () => {
  const {
    idGrupo
  } = (0, _utils.jwtGet)();
  const groupIs = idGrupo !== '0';
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_style.StyleWrapper, null, _react.default.createElement(_search.default, null), _react.default.createElement(_logo.default, null), _react.default.createElement(_style.StyleMenu, null, _react.default.createElement(_style.StyleContainer, null, _react.default.createElement(_group.default, {
    groupIs: groupIs
  })), _react.default.createElement(_icon.default, null, _react.default.createElement(_intercom.default, null)), _react.default.createElement(_icon.default, null, _config.default.header.modules.hasCDN && _react.default.createElement(_notification.default, null)), _react.default.createElement(_user.default, null))), _react.default.createElement(_style.StyleContainerGroup, null, _react.default.createElement(_group.default, {
    groupIs: groupIs
  })));
};
exports.default = _default;